import type {ModelChangeMessageType} from './types';

type ModelChangeHandlerFuncType = (message: ModelChangeMessageType) => void;

class ModelSubscriptionRegistry {
  handlers: Array<ModelChangeHandlerFuncType> = [];

  register(handler: ModelChangeHandlerFuncType) {
    this.handlers = [...this.handlers, handler];
  }

  unregister(handler: ModelChangeHandlerFuncType) {
    this.handlers = this.handlers.filter((f) => f !== handler);
  }

  process(message: ModelChangeMessageType) {
    this.handlers.map((handler) => handler(message));
  }
}

export const modelSubscriptionRegistry = new ModelSubscriptionRegistry();

class ChatSubscriptionRegistry {
  handlers: Array<any> = [];

  register(handler: any) {
    this.handlers = [...this.handlers, handler];
  }

  unregister(handler: any) {
    this.handlers = this.handlers.filter((f) => f !== handler);
  }

  process(message: any) {
    this.handlers.map((handler) => handler(message));
  }
}

export const chatSubscriptionRegistry = new ChatSubscriptionRegistry();
